module.exports = __webpack_public_path__ + "static/media/28.28caddc7.svg";